export default {
  loginTitle: 'TraceHub',
  loginBtn: '登 录',
  logout: '退出',
  logoTip: '确定退出吗？',
  oktaError: '您未经授权，请联系管理部门',
  shortcutKey: '*快捷键快速登录',
  noChannelInfo: '请为该手持枪添加渠道权限信息。',
  deviceNotRegisteredTitle: '扫码枪未注册',
  deviceNotRegisteredContent: '该扫码枪暂未注册在NDC系统中，请先提供相应的扫码枪编号及Mac地址进行注册。'
}
